"use strict";

exports.__esModule = true;
exports["default"] = createGetFormAsyncErrors;

function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
    };
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/selectors/getFormAsyncErrors.js
 ** module id = 1973
 ** module chunks = 0
 **/